export function formatTestDate(value: unknown, withTime = false) {
  const raw = value && typeof value === 'object' && 'iso' in value ? String((value as { iso?: string }).iso || '') : typeof value === 'string' ? value : '';
  const date = raw ? new Date(raw) : undefined;
  if (!date || Number.isNaN(date.getTime())) return 'No date set';
  return date.toLocaleDateString('en-IN', withTime ? { dateStyle: 'medium', timeStyle: 'short' } : { dateStyle: 'medium' });
}

export function inputDateValue(value: unknown) {
  const raw = value && typeof value === 'object' && 'iso' in value ? String((value as { iso?: string }).iso || '') : typeof value === 'string' ? value : '';
  const date = raw ? new Date(raw) : undefined;
  return date && !Number.isNaN(date.getTime()) ? date.toISOString().slice(0, 16) : '';
}

export function pointerId(value: unknown) {
  if (value && typeof value === 'object' && 'objectId' in value) return String((value as { objectId?: string }).objectId || '');
  if (typeof value === 'string' && value.includes('$')) return value.split('$').pop() || '';
  return typeof value === 'string' ? value : '';
}

export function plainText(value: unknown) {
  return String(value || '').replace(/<[^>]*>/g, ' ').replace(/&nbsp;/gi, ' ').replace(/&amp;/gi, '&').replace(/\s+/g, ' ').trim();
}

export function errorMessage(error: unknown, fallback: string) {
  return error instanceof Error && error.message ? error.message : fallback;
}
